const mediaStore = new Map();

export const storeMedia = (mediaId, base64Data, mediaType) => {
  mediaStore.set(mediaId, {
    base64: base64Data,
    type: mediaType,
    timestamp: Date.now(),
  });
};

export const getMedia = (mediaId) => {
  return mediaStore.get(mediaId);
};

export const clearMedia = (mediaId) => {
  mediaStore.delete(mediaId);
};

export const clearAllMedia = () => {
  mediaStore.clear();
};
